import { useEffect, useState } from 'preact/hooks';

// THE ONE PLACE THE PHONE LAYOUT IS DECIDED (README section 11: "Same grid, same data — not
// a second design"). App puts `is-phone` on its root from this, and every phone rule in the
// stylesheets is scoped under `.is-phone`, so the grid's measurements (which JavaScript
// needs) and the page's styles (which CSS applies) can never disagree about which layout
// is showing. Do not add a separate @media width anywhere; read this instead.
export const PHONE_MAX = 640;
const QUERY = `(max-width: ${PHONE_MAX}px)`;

export function usePhone(): boolean {
  const [phone, setPhone] = useState(() => typeof matchMedia === 'function' && matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = matchMedia(QUERY);
    const sync = () => setPhone(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);
  return phone;
}
